exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".editable-box[data-v-1e21ebd2]{position:relative;margin:10px 15px;padding:10px;background:#fff;text-align:center;word-break:break-all}.editable-box .editable-end-tip[data-v-1e21ebd2]{position:absolute;top:0;left:10px;padding:2px 10px;color:#fff;background:#ffb403}.questions-box[data-v-1e21ebd2]{margin:10px 15px}.questions-box.questions-btn[data-v-1e21ebd2]{margin:30px 80px}.editable-message[data-v-1e21ebd2]{padding:20px 0 10px;word-break:break-all}.scrllor-bar[data-v-1e21ebd2]{overflow-y:auto}", ""]);

// exports
